import React, { useState } from "react";

import "./card.css";
import { Card, Offcanvas, Button } from 'react-bootstrap';
// import Collapse from '@mui/material/Collapse';
// import { styled } from '@mui/material/styles';
// import IconButton from '@mui/material/IconButton';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// const ExpandMore = styled((props) => {
//     const { expand, ...other } = props;
//     return <IconButton {...other} />;
//   })(({ theme, expand }) => ({
//     transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
//     marginLeft: 'auto',
//     transition: theme.transitions.create('transform', {
//       duration: theme.transitions.duration.shortest,
//     }),
// }));

function Kartu(props) {
    const { name, jasa, img } = props.services;

    // const [expanded, setExpanded] = useState(false);
    
    // const handleExpandClick = () => {
    //     setExpanded(!expanded);
    // };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            {/* <Card className="svc">
                <Card.Body className="svc-body">
                    <h2 style={{ color: 'black', marginTop: '20px' }}>{name}</h2>
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        style={{ marginLeft: '0px', marginTop: '20px' }}
                        >
                        <ExpandMoreIcon />
                    </ExpandMore>

                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <CardContent className="content">
                            {jasa.map((jas) => (
                                <li style={{  }} id='list'>{jas}</li>
                            ))}
                        </CardContent>
                    </Collapse>
                </Card.Body> 
            </Card> */}

            <Card className="services">
                <Card.Img src={img} className='services-img'/>
                <Card.ImgOverlay className="services-overlay">
                    <h2>{name}</h2>
                    <Button onClick={handleShow} className='services-button' variant='dark'>Click to see more</Button>
                </Card.ImgOverlay>
            </Card>

            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{name}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ul>
                        {jasa.map((jas) => (
                            <li>{jas}</li>
                        ))}
                    </ul>
                    <img src={img}/>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default Kartu;